enum SourceStatus {
  created = 'created',
  transcripting = 'transcripting',
  completed = 'completed',
  error = 'error',
}
export { SourceStatus };

